
      export interface IntrospectionResultData {
        __schema: {
          types: {
            kind: string;
            name: string;
            possibleTypes: {
              name: string;
            }[];
          }[];
        };
      }
      const result: IntrospectionResultData = {
  "__schema": {
    "types": [
      {
        "kind": "UNION",
        "name": "ChatTarget",
        "possibleTypes": [
          {
            "name": "Blog"
          },
          {
            "name": "Show"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ITransaction",
        "possibleTypes": [
          {
            "name": "Ticket"
          },
          {
            "name": "Order"
          },
          {
            "name": "MeetAndGreetTicketPurchase"
          },
          {
            "name": "ManualCredit"
          },
          {
            "name": "Refund"
          },
          {
            "name": "Deposit"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ICustomer",
        "possibleTypes": [
          {
            "name": "User"
          },
          {
            "name": "MeetAndGreetTicketPayment"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IOrderItem",
        "possibleTypes": [
          {
            "name": "OrderPhoto"
          },
          {
            "name": "OrderCitizenship"
          },
          {
            "name": "OrderExpress"
          },
          {
            "name": "OrderMeetAndGreetProduct"
          },
          {
            "name": "OrderPassport"
          },
          {
            "name": "OrderProduct"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IVariant",
        "possibleTypes": [
          {
            "name": "PhotoPrintVariant"
          },
          {
            "name": "MeetAndGreetVariant"
          },
          {
            "name": "CitizenshipVariant"
          },
          {
            "name": "PassportVariant"
          },
          {
            "name": "ProductVariant"
          },
          {
            "name": "ExpressShippingVariant"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IPurchasable",
        "possibleTypes": [
          {
            "name": "MeetAndGreetProduct"
          },
          {
            "name": "PhotoPrint"
          },
          {
            "name": "Citizenship"
          },
          {
            "name": "ExpressShipping"
          },
          {
            "name": "Passport"
          },
          {
            "name": "Product"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IAddress",
        "possibleTypes": [
          {
            "name": "UserAddress"
          },
          {
            "name": "ShowAddress"
          },
          {
            "name": "MeetAndGreetPaymentAddress"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IDocument",
        "possibleTypes": [
          {
            "name": "AboutDocument"
          },
          {
            "name": "CookiesDocument"
          },
          {
            "name": "MeetAndGreetTermsDocument"
          },
          {
            "name": "PrivacyDocument"
          },
          {
            "name": "TermsDocument"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IEnvironment",
        "possibleTypes": [
          {
            "name": "WebEnvironment"
          }
        ]
      }
    ]
  }
};
      export default result;
    